export default __webpack_public_path__ + "static/media/ic-no-announcements.ad736b40.svg";